export const types = {
    login: '[auth] Login',
    logout: '[auth] Logout',
    setSubMenu: '[DB] set sub menu',
    toast: '[error] toast'
};
